import type { JSX } from 'react';
import { Radio } from '@ksyos/design-system';
import { RadioGroupFormGroup } from '../../../processActivityFormGroupFields';
import {
    sortedAstmaCopdOpties,
    sortedComorbiditeitenMedicatieOpties,
} from '../bariPreNurseSpecialistMedScreeningReportUtils';

export function BariPreNurseSpecialistMedScreeningReportComorbiditeitenAdditionalFieldsV2(): JSX.Element {
    return (
        <>
            <RadioGroupFormGroup
                fieldKey="depressie"
                isRequired={true}
                label="Depressie"
            >
                {sortedComorbiditeitenMedicatieOpties.map((value) => (
                    <Radio
                        key={value}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroup>
            <RadioGroupFormGroup
                fieldKey="longziekte_astma_of_copd"
                isRequired={true}
                label="Longziekte (astma of COPD)"
            >
                {sortedAstmaCopdOpties.map((value) => (
                    <Radio
                        key={value}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroup>
        </>
    );
}
